import React, { useEffect, useState } from 'react';

interface UtmParamsData {
  leadSource: string;
  leadMedium: string;
  leadCampaign: string;
  leadTerm: string;
  leadContent: string;
  leadID: string;
  conversionSource: string;
  conversionMedium: string;
  conversionCampaign: string;
  conversionTerm: string;
  conversionContent: string;
  conversionID: string;
}

const UtmData = (): UtmParamsData => {
  const [utmParamsData, setUtmParamsData] = useState<UtmParamsData>({
    leadSource: ' ',
    leadMedium: ' ',
    leadCampaign: ' ',
    leadTerm: ' ',
    leadContent: ' ',
    leadID: ' ',
    conversionSource: ' ',
    conversionMedium: ' ',
    conversionCampaign: ' ',
    conversionTerm: ' ',
    conversionContent: ' ',
    conversionID: ' ',
  });
  const [updateCount, setUpdateCount] = useState(0);

  const updateUTMData = () => {
    const lead = localStorage.getItem('lead');
    if (lead) {
      try {
        const restoredLead = JSON.parse(lead);
        setUtmParamsData((prevUtmParamsData) => ({
          ...prevUtmParamsData,
          leadSource: restoredLead.source,
          leadMedium: restoredLead.medium,
          leadCampaign: restoredLead.campaign,
          leadTerm: restoredLead.term,
          leadContent: restoredLead.content,
          leadID: restoredLead.ID,
        }));
      } catch (error) {
        console.error('Error parsing lead data:', error);
      }
    }

    const conversion = localStorage.getItem('conversion');
    if (conversion) {
      try {
        const restoredConversion = JSON.parse(conversion);
        setUtmParamsData((prevUtmParamsData) => ({
          ...prevUtmParamsData,
          conversionSource: restoredConversion.source,
          conversionMedium: restoredConversion.medium,
          conversionCampaign: restoredConversion.campaign,
          conversionTerm: restoredConversion.term,
          conversionContent: restoredConversion.content,
          conversionID: restoredConversion.ID,
        }));
      } catch (error) {
        console.error('Error parsing conversion data:', error);
      }
    }
  };

  useEffect(() => {
    if (updateCount < 2) {
      updateUTMData();
      setUpdateCount(updateCount + 1);
    }
  }, [updateCount]);

  return utmParamsData;
};

export default UtmData;
